import { render, staticRenderFns } from "./about-dex.vue?vue&type=template&id=25f5d14a&"
import script from "./about-dex.vue?vue&type=script&lang=js&"
export * from "./about-dex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports